import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ExecuteContractRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { ExecuteContractResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const executeContract = (request: ExecuteContractRequest, options?: CashRequestOptions) =>
  post<ExecuteContractRequest, ExecuteContractResponse>('/2.0/cash/execute-contract', request, {
    ...options,
    rejectOnError: true,
  })
